import styles from "./style.module.css";
import { ReactComponent as SkalebotLogo } from "../../assets/svgIcons/Skalebot.svg";
import { ReactComponent as HumburgerMenu } from "../../assets/navbarIcons/menu.svg";
import { ReactComponent as Cancel } from "../../assets/svgIcons/cancel.svg";
import {
  changeSidebarOpenStatus,
  changeSidebarCollapsed,
} from "../../reducers/appSlice";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

const pageMeta = [
  {
    matches: ["/dashboard"],
    title: "",
    subtitle: "",
    section: "Overview",
  },
  {
    matches: ["/companies", "/company"],
    title: "Company Operations",
    subtitle: "",
    section: "Accounts",
  },
  {
    matches: ["/notifications"],
    title: "Notification Center",
    subtitle: "",
    section: "Engagement",
  },
  {
    matches: ["/userprofile"],
    title: "Account Profile",
    subtitle: "",
    section: "Profile",
  },
  {
    matches: ["/tickets/dashboard"],
    title: "Support Analytics",
    subtitle: "",
    section: "Support",
  },
  {
    matches: ["/tickets/workspace"],
    title: "Ticket Workspace",
    subtitle: "",
    section: "Support",
  },
  {
    matches: ["/tickets/"],
    title: "Ticket Details",
    subtitle: "",
    section: "Support",
  },
  {
    matches: ["/tickets"],
    title: "Ticket Operations",
    subtitle: "",
    section: "Support",
  },
];

const resolvePageMeta = (pathname) =>
  pageMeta.find((item) =>
    item.matches.some((match) =>
      pathname === match || pathname.startsWith(`${match}/`) || pathname.startsWith(match)
    )
  ) || {
    title: "SkaleBot Admin",
    subtitle: "",
    section: "Workspace",
  };

function Header() {
  const { slidebarOpen } = useSelector((state) => state.application);
  const { user } = useSelector((state) => state.authenticate);
  const dispatch = useDispatch();
  const location = useLocation();
  const meta = resolvePageMeta(location.pathname);
  const hasTitle = Boolean(meta.title);
  const hasSubtitle = Boolean(meta.subtitle);

  const displayName = user?.name || user?.userName || user?.email || "Administrator";
  const initials = String(displayName).trim().charAt(0).toUpperCase() || "A";

  const handleSlide = () => {
    if (window.innerWidth <= 1000) {
      dispatch(changeSidebarOpenStatus());
      return;
    }
    dispatch(changeSidebarCollapsed());
  };

  return (
    <div className={styles.headerShell}>
      <div className={styles.header}>
        <div className={styles.leftCluster}>
          <button
            type="button"
            className={styles.menuButton}
            onClick={handleSlide}
            aria-label="Toggle navigation"
          >
            {slidebarOpen ? <Cancel /> : <HumburgerMenu />}
          </button>

          <div className={styles.brandBlock}>
            <div className={styles.logoWrap}>
              <SkalebotLogo className={styles.logo} />
            </div>
            <div className={styles.titleBlock}>
              <span className={styles.kicker}>SkaleBot Admin Suite</span>
              {(hasTitle || hasSubtitle) && (
                <div className={styles.titleRow}>
                  {hasTitle && <strong>{meta.title}</strong>}
                  {hasTitle && hasSubtitle && <span className={styles.titleDivider} />}
                  {hasSubtitle && <span>{meta.subtitle}</span>}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={styles.rightCluster}>
          <div className={styles.infoChip}>
            <span>Workspace</span>
            <strong>{meta.section}</strong>
          </div>
          <div className={styles.userChip}>
            <div className={styles.avatar}>{initials}</div>
            <div className={styles.userText}>
              <span>Signed in</span>
              <strong>{displayName}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
